import { destoryItem } from "./utils.js";

/*
 * Hides the main board and adds a focus contianer that will hold the special content
 */
function createFocusContainer({ board }) {
  const focusContainer = document.createElement("div");
  focusContainer.classList.add("focus-container");
  board.classList.add("transition--500");

  // Transition out the board and transition in the special items
  setTimeout(() => {
    board.classList.add("poof")
  }, 10);
  setTimeout(() => {
    board.classList.add("hidden");
    document.body.insertBefore(focusContainer, null);
  }, 500);

  return focusContainer;
}

/*
 * Removes the focus container and restore the main board
 */
function removeFocusContainer(container, { board }) {
  destoryItem(container, false);
  board.classList.remove("hidden");
  setTimeout(() => { board.classList.remove("poof") }, 10)
}

/*
 * totalSeconds - timer seconds in seconds 
 * timer will run for that many seconds and then call the callback funcition
 * callback - function to call once the timer runs down
 * */
function addTimer(totalSeconds, callback) {
  let seconds = totalSeconds;
  const timerDiv = document.createElement("div");
  const timerText = document.createElement("p");
  timerDiv.classList.add("timer");
  timerDiv.appendChild(timerText);
  timerText.innerText = `Time left: ${seconds}s`;

  function startTimer() {
    const actionTime = setInterval(() => {
      if (seconds > 0) {
        timerText.innerText = `Time left: ${--seconds}s`;
      }
      else {
        timerText.innerText = `Times up`;
        if (typeof callback === "function") {
          callback();
        }
        clearInterval(actionTime);
      }
    }, 1000);

    // setTimeout( ()=> { clearInterval(actionTime)}, seconds * 1050);
    return actionTime;
  }

  function stopTimer(timerId, callback) {
    clearInterval(timerId);
    if (typeof callback === "function") {
      callback();
    }
  }

  function getSeconds() {
    return seconds;
  }

  return { timerDiv, startTimer, stopTimer, getSeconds };
}

export { createFocusContainer, removeFocusContainer, addTimer }
